import { getLoginInfo } from '../authentication';

export const userSpecificApiKey = (featureKey: string) => `${featureKey}-${getLoginInfo()?.user?.id}`;
